import { CanActivateFn, Router } from "@angular/router";
import { inject } from "@angular/core";
import { FidaiFeatureService } from "../../screens/ai/services/fidai-feature.service";

export const aiDashboardGuard: CanActivateFn = () => {
  const router = inject(Router);
  const fidaiFeatureService = inject(FidaiFeatureService);

  if (!fidaiFeatureService.isAiDashboardEnabled()) {
    router.navigate(["/home"], { replaceUrl: true });
    return false;
  }

  return true;
};
